export default {
  loaded: false,
  mode: 'intro', // Can be intro, tutorial, playing, paused or gameover
  showOverlay: false,
  tutorialDone: false,

  score: 0,
  coins: 0,
  life: 3,
  level: 1,

  userData: { score: 0, userName: 'userName', scoreRange: [] },
};
